<template>
  <v-container fill-height fluid grid-list-xl>
    <v-row justify="center">
      <v-col cols="12">
        <material-card
          color="green"
          flat
          full-width
          title="Заказы"
        >
          <router-link to="/orders/view" target="_blank">
            Создать новый заказ
          </router-link>
          <a href="#" onclick="return false" @click="exportOrders" style="margin-left: 20px;">Экспорт</a>
          <v-progress-circular
            v-if="exportLoadingVisible"
            indeterminate
            :size="15"
            color="primary"
            :width="2"
          ></v-progress-circular>
          <v-data-table
            :headers="headers"
            :items="data"
            :options.sync="options"
            :server-items-length="totalDesserts"
            :loading="loading"
            class="elevation-1"
          >
            <template #body.prepend>
              <tr>
                <td>
                  <v-text-field
                    v-model="filterId"
                    clearable
                  />
                </td>
                <td>
                  <v-text-field
                    v-model="filterCustomer"
                    clearable
                    label="ФИО, Email, телефон"
                  />
                </td>
                <td></td>
                <td>
                  <v-menu
                    v-model="dateCreatedVis"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        v-model="filterCreatedAt"
                        readonly
                        v-bind="attrs"
                        clearable
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filterCreatedAt"
                      no-title
                      locale="RU"
                      @input="dateCreatedVis = false"
                    ></v-date-picker>
                  </v-menu>
                </td>
                <td></td><td>
                  <v-select
                    v-model="filterDelivery"
                    :items="deliveriesList"
                    clearable
                  />
                </td><td>
                  <v-select
                    v-model="filterPayment"
                    :items="paymentsList"
                    clearable
                  />
                </td>
                <td>
                  <v-select
                    v-model="filterStatus"
                    :items="statusList"
                    clearable
                  />
                </td>
                <td>
                  <v-text-field
                    v-model="filterOffer"
                    clearable
                    label="код, название"
                  />
                </td>
                <td></td>
              </tr>
            </template>
            <template #top>
              <v-toolbar flat>
                <v-text-field v-model="search" label="Поиск" class="mx-4" />
              </v-toolbar>
            </template>
            <template #item.customer="{ item }">
              {{ item.customerName }}<br>
              {{ item.customerPhone }}<br>
              {{ item.customerEmail }}<br>
              {{ item.customerComment }}<br>
            </template>
            <template #item.createdAt="{ item }">
              {{ new Date(item.createdAt * 1000).toLocaleString("ru-RU") }}
            </template>
            <template #item.status="{ item }">
              {{ getStatus(item) }}
            </template>
            <template #item.count="{ item }">
              {{ item.items.length }}
            </template>
            <template #item.actions="{ item }">
              <router-link :to="{ path: '/orders/view/' + item.id }" target="_blank">
                <v-icon small class="mr-2">
                  mdi-pencil
                </v-icon>
              </router-link>
              <v-dialog
                transition="dialog-bottom-transition"
                width="500"
                :value="deleteDialog === item.id"
                @input="toggleDeleteDialog($event, item.id)"
              >
                <template #activator="{ on, attrs }">
                  <v-tooltip top>
                    <template #activator="{ on: tooltipActions, attrs: tooltipAttrs }">
                      <span v-bind="tooltipAttrs" v-on="tooltipActions">
                        <v-icon tag="i" v-bind="attrs" small class="mr-2" v-on="on">
                          mdi-delete
                        </v-icon>
                      </span>
                    </template>
                    Удалить
                  </v-tooltip>
                </template>
                <v-card>
                  <v-toolbar color="primary" dark class="text-center mb-6">
                    Подтвердите Действие
                  </v-toolbar>
                  <v-card-text>
                    Вы точно хотите удалить запись?
                  </v-card-text>
                  <v-card-actions class="justify-end">
                    <v-btn color="tertiary" dark @click="deleteDialog = null">
                      Отменить
                    </v-btn>
                    <v-btn color="primary" @click="deleteItem(item.id)">
                      Удалить
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
          </v-data-table>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { deleteOrder, exportOrders, getOrders } from '@/graphql/orders'
import orderMixin from '@/helpers/orders'
import { getDeliveries } from '@/graphql/deliveries'
import { getPayments } from '@/graphql/payments'
import { downloadFile } from '@/components/core/fileUtils'
export default {
  Name: 'OrderList',
  mixins: [orderMixin],
  layout: 'dashboard',
  apollo: {
    orders: {
      query: getOrders,
      result ({ data, loading }) {
        if (data.orders.data !== null) {
          this.data = data.orders.data
          this.totalDesserts = data.orders.totalCount
        }
        this.loading = false
      },
      variables () {
        return {
          filter: this.getFilters(),
          limit: this.options.itemsPerPage,
          offset: this.options.itemsPerPage * (this.options.page - 1)
        }
      },
      update: data => data?.orders?.data

    },
    deliveries: {
      query: getDeliveries,
      variables () {
        return {
          filter: {
            status: 'ACTIVE'
          }
        }
      },
      result ({ data, loading }) {
        if (data?.deliveries?.data) {
          this.deliveriesList = data.deliveries.data.map(function (item) {
            return { text: item?.name + '(' + item.group_name + ')', value: parseInt(item?.id) }
          })
        }
        this.loading = false
      },
      update: data => data?.deliveries?.data

    },
    payments: {
      query: getPayments,
      variables () {
        return {
          filter: {
            status: 'ACTIVE'
          }
        }
      },
      result ({ data, loading }) {
        if (data?.payments?.data) {
          this.paymentsList = data.payments.data.map(function (item) {
            return { text: item?.name, value: parseInt(item?.id) }
          })
        }
        this.loading = false
      },
      update: data => data?.payments?.data

    }
  },
    data () {
    return {
      search: '',
      deliveriesList: [],
      paymentsList: [],
      options: {},
      loading: false,
      exportLoadingVisible: false,
      data: [],
      deliveriesData: [],
      paymentsData: [],
      filterCustomer: '',
      filterOffer: '',
      filterStatus: '',
      filterCreatedAt: '',
      filterId: '',
      filterDelivery: '',
      filterPayment: '',
      dateCreatedVis: false,
      totalDesserts: 0,
      deleteDialog: false,
      headers: [
        {
          sortable: false,
          text: 'Id',
          value: 'id'
        },
        {
          sortable: false,
          text: 'Клиент',
          value: 'customer'
        },
        {
          sortable: false,
          text: 'Коментарий Менеджера',
          value: 'managerComment'
        },
        {
          sortable: false,
          text: 'Дата размещения',
          value: 'createdAt'
        },
        {
          sortable: false,
          text: 'Сумма заказа',
          value: 'sumTotal'
        },
        {
          sortable: false,
          text: 'Доставка',
          value: 'deliveryName'
        },
        {
          sortable: false,
          text: 'Оплата',
          value: 'paymentName'
        },
        {
          sortable: false,
          text: 'Статус',
          value: 'status'
        },
        {
          sortable: false,
          text: 'товаров',
          value: 'count'
        },
        {
          sortable: false,
          text: ' ',
          value: 'actions'
        }
      ]
    }
  },
  methods: {
    getFilters () {
      const filter = {}
      if (this.filterId) {
        filter.id = this.filterId
      }
      if (this.filterCustomer) {
        filter.customer = this.filterCustomer
      }
      if (this.filterOffer) {
        filter.offer = this.filterOffer
      }
      if (this.filterStatus) {
        filter.status = this.filterStatus
      }
      if (this.filterCreatedAt) {
        filter.createdAt = this.filterCreatedAt
      }
      if (this.filterDelivery) {
        filter.deliveryId = this.filterDelivery
      }
      if (this.filterPayment) {
        filter.paymentId = this.filterPayment
      }

      return filter
    },
    toggleDeleteDialog (value, slug) {
      this.deleteDialog = value
          ? slug
          : null
    },
    deleteItem (id) {
      this.$apollo
          .mutate({
            mutation: deleteOrder,
            variables: {
              id
            }
          })
          .then((data) => {
            this.$apollo.queries.orders.refetch()
          })
          .catch((error) => {
            console.error(error)
          })
    },
    exportOrders () {
      this.exportLoadingVisible = true
      this.$apollo
          .mutate({
            mutation: exportOrders,
            variables: {
              filter: this.getFilters()
            }
          })
          .then((data) => {
            downloadFile('orders.csv', data?.data?.exportOrders)
            this.exportLoadingVisible = false
          })
          .catch((error) => {
            console.error(error)
            this.exportLoadingVisible = false
          })

      return false
    }
  }
}
</script>
